import script from "./CartCustomerOrderNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartCustomerOrderNumber.vue?vue&type=script&setup=true&lang=ts"

import "./CartCustomerOrderNumber.vue?vue&type=style&index=0&id=1b686566&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b686566"]])

export default __exports__